import {createAction} from 'typesafe-actions';
import * as Types from './types';

export const setTempSelections = createAction(
  '@view/groupSelections/setTempSelections',
  action => (ref: Types.Ref, tempSelections: Types.TempSelection) =>
    action({ref, tempSelections})
);
